<!--
* UIID: UI-CAAS-COM-111
* UI Name: sFTP
* Modify Date: 2020/06/15
-->
<template>
  <div>
    <v-form ref="form">
      <!-- 2 Row 54px-->
      <v-row>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Host</v-label>
          <v-text-field
            v-model="formData.host"
            :rules="[validationUtils.required, validationUtils.min(8), validationUtils.max(100)]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-row>
            <v-col cols="12" md="8" class="py-0 pr-1">
              <v-label>Security</v-label>
              <v-select
                v-model="formData.security"
                :items="securities"
                solo
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Port</v-label>
              <v-text-field
                v-model="formData.port"
                type="number"
                :rules="[validationUtils.required, validationUtils.max(5)]"
                solo
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!--3 Row 40px-->
      <v-row class="mt-0">
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>User ID</v-label>
          <v-text-field
            v-model="formData.userid"
            :rules="[validationUtils.required, validationUtils.max(200)]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-row>
            <v-col cols="12" md="8" class="pr-0">
              <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Password</v-label>
              <v-text-field
                v-model="passwordField"
                :append-icon="formData.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="formData.showpassword ? 'text' : 'password'"
                @click:append="formData.showpassword = !formData.showpassword"
                :rules="passwordRules"
                :readonly="isPasswordViewMode"
                solo
                :disabled="!$auth.manage"
                autocomplete="new-password"
                @focus="handlePasswordType"
                @blur="handlePasswordType"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-btn
                v-if="isPasswordViewMode"
                class="btn btn-popup-search mt-7"
                block
                height="40"
                color="primary"
                @click="startEditPassword"
              >
                Change
              </v-btn>
              <v-btn
                v-else-if="hasStoredPassword"
                class="btn btn-close mt-7"
                block
                height="40"
                @click="cancelEditPassword"
              >
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!--4 Row -->
      <v-row class="mt-0">
        <v-col cols="12" md="6" class="px-2 py-0" style="position: relative;">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Down/Upload Path</v-label>
          <v-text-field
            v-model="formData.path"
            :rules="[validationUtils.required, validationUtils.max(200)]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
          <v-checkbox
            v-model="formData.ftpAutoDir"
            label="Auto Create sFTP Directory"
            dense
            true-value="Y"
            false-value="N"
            hide-details="true"
            class="ftp-auto-dir"
          ></v-checkbox>
        </v-col>
        <!-- // 2021.8.9 203728  SPKA-178 Add "Filename Pattern" to communication (only for FTP, sFTP) -->
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label>{{ $t('lbl.communications.getFileNmPttn') }}</v-label>
          <v-text-field
            v-model="formData.fileNmPttn"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="px-2 py-0">
          <v-label>Private Key</v-label>
          <v-textarea solo v-model="formData.privatekey" :readonly="isHistory"></v-textarea>
        </v-col>
        <v-col cols="12" md="12" class="px-2 py-0">
          <v-label>Passphrase</v-label>
          <v-text-field
            v-model="formData.passphrase"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
      </v-row>
      <!--5 Row -->
      <v-row class="mt-0">
        <v-col cols="12" md="12" class="px-2 py-0">
          <v-row class="mt-0">
            <v-col cols="12" md="4" class="py-0 pr-1">
              <v-label
                ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                >{{ $t('lbl.communications.exeInterval') }}</v-label
              >
              <v-text-field
                v-model="formData.interval"
                type="number"
                :rules="[validationUtils.required, validateInterval(intervalDefault)]"
                solo
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="py-0 pr-1">
              <v-select
                v-model="intervalDefault"
                :items="intervals"
                solo
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                return-object
                style="margin-top: 22px !important;"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <v-label>{{ $t('lbl.communications.maxRetryAttempts') }}</v-label>
              <v-text-field
                v-model="formData.maxRetry"
                type="number"
                solo
                :disabled="!$auth.manage"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <!-- /**
            * 2021.09.28 203737 SPKA-218 Add item in Communication (FTP, sFTP)
            */ -->
        <v-col cols="12" md="12" class="px-2 py-0">
          <v-row class="ml-0 mr-0 d-block">
            <v-col lg="11" class="pa-0 pt-6">
              <v-label>{{ $t('lbl.communications.putFileNmPttn') }}</v-label>
              <v-tooltip top :disabled="listPattern.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip pl-3">
                    <v-col lg="1" class="pa-0 text-right">
                      <v-icon
                        dense
                        @click="addPattern()"
                        :disabled="!$auth.manage || listPattern.length >= maxPattern"
                        :readonly="isHistory"
                        class="pb-1"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-form ref="formHttpHeaders" class="form-identification pr-0">
            <v-row
              class="ml-0 mr-0 edi-identification-right"
              v-for="(item, index) in listPattern"
              :key="item.id"
            >
              <v-col cols="12" md="4" class="pa-0">
                <v-tooltip top :disabled="!item.isValidatePattern">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-select
                        :ref="'PTTN_' + item.id"
                        v-model="item.keyPattern"
                        :items="listComboFilenamePattern"
                        solo
                        :menu-props="{ offsetY: true }"
                        hide-details
                        :disabled="!$auth.manage"
                        :readonly="isHistory"
                        @change="validatePattern(item)"
                        :rules="item.isValidatePattern ? [''] : []"
                      ></v-select>
                    </div>
                  </template>
                  <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="7" class="pa-0 pl-4">
                <v-text-field
                  :ref="'PTTN_' + item.id + '_' + item.id"
                  solo
                  hide-details
                  v-model="item.valuePattern"
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-0 mt-4 text-right">
                <v-icon
                  dense
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                  @click="removePattern(index)"
                >
                  mdi-minus
                </v-icon>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-form>
    <dialogWindow
      ref="DuplicatePatternDialog"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    >
    </dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { getEditData } from '@/vue-caas/utils/process';

const PWD_DUMMY = '••••••••••••';

export default {
  components: {
    dialogWindow,
  },
  props: {
    item: {
      type: Object,
    },
    nodeId: {
      type: String,
    },
    isHistory: {
      default: false,
    },
  },

  data() {
    return {
      securities: [
        { text: 'NONE', value: 'NONE' },
        { text: 'SSL', value: 'SSL' },
        { text: 'TLS', value: 'TLS' },
      ],
      inouts: [
        { value: 'I', text: 'INBOUND' },
        { value: 'O', text: 'OUTBOUND' },
      ],
      formData: {},
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
      intervals: [
        { text: this.$t('msg.communications.seconds'), value: 'SS' },
        { text: this.$t('msg.communications.minutes'), value: 'MM' },
        { text: this.$t('msg.communications.hours'), value: 'HH' },
      ],
      intervalDefault: {
        text: this.$t('msg.communications.minutes'),
        value: 'MM',
      },
      listComboFilenamePattern: [],
      listPattern: [],
      setPattern: new Set(),
      isValidatePattern: false,
      listPatternType: [],
      maxPattern: 0,
      isDuplicatePattern: false,
      checkDialogColor: 'warning',
      checkDialogInfo: '',
      passwordState: 'unchanged',
      hasStoredPassword: false,
      editingPassword: false,
    };
  },

  computed: {
    isPasswordViewMode() {
      return this.hasStoredPassword && !this.editingPassword;
    },

    passwordField: {
      get() {
        return this.isPasswordViewMode ? PWD_DUMMY : this.formData.password;
      },
      set(v) {
        if (this.isPasswordViewMode) return;
        this.formData.password = v;
        this.passwordState = v.length ? 'replace' : 'unchanged';
      },
    },

    passwordRules() {
      if (this.isPasswordViewMode) return [];
      if (this.hasStoredPassword) return [this.validationUtils.max(20)];
      return [this.validationUtils.required, this.validationUtils.max(20)];
    },
  },

  created() {
    this.resetFormData();
  },

  watch: {
    item() {
      this.resetFormData();
      // this.setFocus();
    },
  },

  methods: {
    startEditPassword() {
      this.editingPassword = true;
      this.formData.showpassword = false;
      this.formData.password = '';
      this.passwordState = 'unchanged';
      this.$nextTick(() => this.$refs.passwordInput?.focus());
    },

    cancelEditPassword() {
      this.editingPassword = false;
      this.formData.showpassword = false;
      this.formData.password = '';
      this.passwordState = 'unchanged';
    },
    handlePasswordType(event) {
      const { srcElement, type } = event;
      const { value } = srcElement;
      if (type === 'focus' && !value) {
        this.formData.showpassword = false;
      }
      if (type === 'blur' && !value) {
        this.formData.showpassword = true;
      }
    },

    checkDataChange() {
      let editedData = getEditData(this.formData, this.loadFormData);
      this.$emit('check-data-change', editedData);
    },
    async save(item) {
      /**
       * 2021.09.28 203737 SPKA-218 Add item in Communication (FTP, sFTP)
       */
      const validResult = this.$refs.form.validate();
      if (!validResult) return -1;
      this.formData.id = item.id;
      this.formData.type = item.type;
      this.formData.name = item.name;
      this.formData.protocol = item.type;
      const indexValidPattern = this.listPattern.findIndex(
        (e) => e.keyPattern === '' || e.valuePattern === '',
      );
      if (indexValidPattern > -1) {
        const itemPattern = this.listPattern[indexValidPattern];
        this.$refs[
          `PTTN_${itemPattern.id}${itemPattern.keyPattern === '' ? '' : '_' + itemPattern.id}`
        ][0].focus();
        return -1;
      }
      if (this.isDuplicatePattern) {
        this.$refs.DuplicatePatternDialog.dialog = true;
        this.checkDialogInfo = this.$t('msg.communications.validDuplicatePattern');
        return -1;
      }
      this.listPatternType.map((item) => {
        this.formData[item] = null;
      });
      this.listPattern.map((item) => {
        this.formData[item.keyPattern] = item.valuePattern;
      });

      if (this.intervalDefault && this.intervalDefault.value) {
        this.formData.intervalType = this.intervalDefault.value;
      }

      this.formData.protocol = this.formData.type;
      let submitData;

      if (this.formData.id) {
        submitData = getEditData(this.formData, this.loadFormData);

        submitData.id = this.formData.id;
        submitData.name = this.formData.name;
        submitData.type = this.formData.type;
        submitData.protocol = this.formData.type;

        if (this.passwordState === 'replace' && this.formData.password) {
          submitData.password = this.formData.password;
        } else {
          delete submitData.password;
        }
        delete submitData.showpassword;

        await this.$store
          .dispatch('editCommFromProcSetup', submitData)
          .then(() => {
            this.sendActivate(this.formData.id, 'COM', submitData);
            let formEmit = {
              comId: this.formData.id,
              nodeId: this.nodeId,
              type: 'COM',
            };
            EventBus.$emit('refresh-list-component', formEmit);
          })
          .catch((err) => {
            alert(err);
          });
      } else {
        submitData = { ...this.formData };
        delete submitData.showpassword;
        await this.$store
          .dispatch('insertCommFromProcSetup', submitData)
          .then(() => {
            this.formData.id = this.$store.getters.communicationId;
            let formEmit = {
              comId: this.formData.id,
              nodeId: this.nodeId,
              type: 'COM',
            };
            EventBus.$emit('refresh-list-component', formEmit);
          })
          .catch((err) => {
            alert(err);
          });
      }
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },

    getInitData() {
      return {
        name: '',
        partner: '',
        direction: '',
        host: '',
        security: '',
        port: '',
        userid: '',
        password: '',
        showpassword: true,
        path: '',
        interval: '',
        type: 'SFTP',
        ftpAutoDir: false,
      };
    },
    // hasEditForm() {
    //   const defaultForm = this.getInitData();
    //   for (const prop in defaultForm) {
    //     if (prop != "showpassword" && prop != "type") {
    //       if (this.formData[prop].trim() != "") {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // },
    resetFormData() {
      this.formData = Object.assign({}, this.getInitData(), this.item);
      if (!this.formData.interval) {
        this.formData.interval = '30';
      }

      if (this.item.intervalType) {
        this.intervalDefault = this.intervals.filter(
          (item) => item.value === this.item.intervalType,
        )[0];
      } else {
        this.intervalDefault = {
          text: this.$t('msg.communications.minutes'),
          value: 'MM',
        };
      }

      this.hasStoredPassword = Boolean(this.item && this.item.hasPassword);
      this.formData.password = '';
      this.formData.showpassword = false;
      this.passwordState = 'unchanged';
      this.editingPassword = !this.hasStoredPassword;

      this.loadFormData = Object.assign({}, this.getInitData(), this.item);
      this.loadFormData.password = '';
      this.loadFormData.showpassword = false;

      this.listComboFilenamePattern = [];
      this.listPattern = [];
      this.setPattern = new Set();
      this.listPatternType = [];
      this.getListComboFilenamePattern();
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.name.focus();
      }, 300);
    },
    validateInterval(item) {
      let interval = this.formData.interval;
      if (interval) {
        switch (item.value) {
          case 'SS': {
            // 05/31/2021 203737 SPKA-127 issue 76 Change minimum interval value for "Seconds" from 30 to 10. (validation allow 10~59 seconds)
            if (interval < 10 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['10', '59', 'seconds']);
            }
            break;
          }
          case 'HH': {
            if (interval < 1 || interval > 24) {
              return this.$t('msg.communications.validateInterval', ['1', '24', 'hours']);
            }
            break;
          }
          default: {
            if (interval < 1 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['1', '59', 'minutes']);
            }
          }
        }
      }
      return true;
    },
    getListComboFilenamePattern() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P10' }).then(() => {
        this.$store.getters['caascommon/comCdList'].map((e) => {
          this.listComboFilenamePattern.push({
            text: e.text,
            value: e.value,
          });
        });
        this.getListPatternType();
      });
    },
    addPattern() {
      console.log('this.formData', this.formData);
      let index =
        this.listPattern.length > 0 ? this.listPattern[this.listPattern.length - 1].id + 1 : 1;
      this.listPattern.push({
        id: index,
        keyPattern: '',
        valuePattern: '',
        isValidatePattern: false,
      });
    },
    removePattern(index) {
      this.listPattern.splice(index, 1);
      this.resetSetPattern();
    },
    validatePattern(itemChange) {
      let indexValid = this.listPattern.findIndex((e) => e.id === itemChange.id);
      if (this.setPattern.has(itemChange.keyPattern)) {
        this.isDuplicatePattern = true;
        this.listPattern[indexValid].isValidatePattern = true;
      } else {
        this.isDuplicatePattern = false;
        this.listPattern[indexValid].isValidatePattern = false;
      }
      this.resetSetPattern();
    },
    getListPatternType() {
      this.listComboFilenamePattern.map((item) => {
        this.listPatternType.push(item.value);
      });
      Object.keys(this.formData).map((item, index) => {
        if (this.listPatternType.includes(item) && this.formData[item]) {
          let obj = {
            id: index + 1,
            keyPattern: item,
            valuePattern: this.formData[item],
            isValidatePattern: false,
          };
          this.listPattern.push(obj);
          this.setPattern.add(item);
        }
      });
      this.maxPattern = this.listPatternType.length;
    },
    resetSetPattern() {
      this.setPattern.clear();
      this.listPattern.map((item) => {
        if (item.keyPattern !== '') {
          this.setPattern.add(item.keyPattern);
        }
      });
    },
    closeDialog() {
      this.$refs.DuplicatePatternDialog.dialog = false;
    },
  },
};
</script>
